import request from '@/plugin/axios/flsc2'

export function AccountLogin (params, data) {
  console.log('params',params)
  let url = 'index.php?'
  if (params) {
    if (params.length > 1) {
      console.log('1')
      let arr = []
      for (let k in params) {
        console.log('params[k]',params[k])
        arr.push((k + '=' + params[k]))
      }
      url = arr.join('&')
    } else {
      console.log('2')
      for (let k in params) {
        console.log('k',k)
        console.log('params[k]',params[k])
        url += (k + '=' + params[k] + '&')
      }
    }
  }
  return request({
    // params,
    url,
    method: 'post',
    data
  })
}
